import { ClinicDaySnapshot } from "../../../@types/clinicDay.types";

/**
 * MOCK DATA - not backed by the database.
 *
 * There is no visit, token, queue or order collection on the server yet, so this
 * module stands in for the endpoint that will eventually serve the front-desk day
 * view. It is the only mocked thing behind the Today's Clinic screen: replace the
 * body of `getClinicDay` with a real `request.get(...)` returning a
 * ClinicDaySnapshot and the screen needs no changes.
 *
 * See src/@types/clinicDay.types.ts for the contract and the domain rules.
 */
const MOCK_SNAPSHOT: ClinicDaySnapshot = {
	clinic: { name: "Kolkata", area: "Ballygunge" },
	summary: {
		registered: { count: 9, walkIn: 4, referred: 5 },
		awaitingConsult: { count: 2 },
		inScanning: { count: 3, deviceLabel: "Kiosk KOL-01" },
		choosingProduct: { count: 2 },
		confirmedToday: { count: 4, bookedAmount: 41480 }
	},
	activeSteps: ["scan_assessment", "additional_questions"],
	queue: [
		{
			token: "T-014",
			name: "Sujata Bhowmick",
			patientId: "P19204",
			age: 54,
			gender: "F",
			isRepeat: false,
			source: { kind: "walk_in" },
			consult: { status: "skipped" },
			currentStep: "scan_assessment",
			stepDetail: null,
			attendant: { name: "Rakesh Barman", detail: "Kiosk KOL-01" },
			waitingMinutes: 6,
			confirmedOrder: null,
			nextAction: { label: "Open", tone: "technician" }
		},
		{
			token: "T-013",
			name: "Abhijit Kar",
			patientId: "P19203",
			age: 61,
			gender: "M",
			isRepeat: false,
			source: { kind: "doctor_referral", referrer: "Dr. Basu" },
			consult: { status: "done", doctor: "Dr. Payel Ghosh" },
			currentStep: "additional_questions",
			stepDetail: null,
			attendant: { name: "Sudipta Roy", detail: "Assessment bay 2" },
			waitingMinutes: 2,
			confirmedOrder: null,
			nextAction: { label: "Open", tone: "technician" }
		},
		{
			token: "T-012",
			name: "Meenakshi Iyer",
			patientId: "P19202",
			age: 47,
			gender: "F",
			isRepeat: false,
			source: { kind: "walk_in" },
			consult: { status: "skipped" },
			currentStep: "choose_product",
			stepDetail: null,
			attendant: { name: "Self · kiosk", detail: "3 options shown" },
			waitingMinutes: 4,
			confirmedOrder: null,
			nextAction: { label: "Open", tone: "ready" }
		},
		{
			token: "T-011",
			name: "Ranjan Dutta",
			patientId: "P14882",
			age: 68,
			gender: "M",
			isRepeat: true,
			source: { kind: "franchise_referral" },
			consult: { status: "done", doctor: "Dr. Arindam Sen" },
			currentStep: "choose_product",
			stepDetail: null,
			attendant: { name: "Mou Chatterjee", detail: "Assisted" },
			waitingMinutes: 9,
			confirmedOrder: null,
			nextAction: { label: "Billing", tone: "ready" }
		},
		{
			token: "T-010",
			name: "Farhan Rahman",
			patientId: "P19201",
			age: 33,
			gender: "M",
			isRepeat: false,
			source: { kind: "walk_in" },
			consult: { status: "waiting" },
			currentStep: "doctor_consult",
			stepDetail: null,
			attendant: { name: "Queue pos. 1", detail: "Dr. Payel Ghosh" },
			waitingMinutes: 18,
			confirmedOrder: null,
			nextAction: { label: "Open", tone: "passive" }
		},
		{
			// Registered before a Patient ID exists - the queue keys on the token.
			token: "T-009",
			name: "Shreya Pal",
			patientId: null,
			age: 29,
			gender: "F",
			isRepeat: false,
			source: { kind: "walk_in" },
			consult: { status: "not_reached" },
			currentStep: "registration",
			stepDetail: "kiosk",
			attendant: { name: "Self · kiosk 2", detail: "Step 2 of 3" },
			waitingMinutes: 3,
			confirmedOrder: null,
			nextAction: { label: "Open", tone: "passive" }
		},
		{
			token: "T-008",
			name: "Nilanjan Bose",
			patientId: "P19199",
			age: 56,
			gender: "M",
			isRepeat: false,
			source: { kind: "walk_in" },
			consult: { status: "skipped" },
			currentStep: "billing",
			stepDetail: null,
			attendant: { name: "Order CF-26-0921", detail: "raised" },
			waitingMinutes: null,
			confirmedOrder: { orderNumber: "CF-26-0921", amount: 9498 },
			nextAction: { label: "View", tone: "complete" }
		}
	]
};

export const getClinicDay = async (): Promise<ClinicDaySnapshot> => {
	return MOCK_SNAPSHOT;
};
